import React from "react";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";

import logo from "../Images/Logos/logo_footer.png";

import maps from "../Images/Icons/maps.svg";
import mail from "../Images/Icons/mail.svg";
import phone from "../Images/Icons/phone.svg";
import face from "../Images/Icons/face.svg";
import linkedin from "../Images/Icons/in.svg";
import insta from "../Images/Icons/insta.svg";
import youtube from "../Images/Icons/youtube.svg";

const Footer = () => {
  return (
    <footer
      id="contacto"
      style={{ scrollMarginTop: "50px" }}
      className="page-footer"
    >
      <Container maxWidth="xl">
        <Grid container spacing={2} sx={{ justifyContent: "space-evenly" }}>
          <Grid
            xs={12}
            md={4}
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img src={logo} alt="DSLatam" style={{ width: "100%" }} />
            <p
              className="texto_2 center_movil"
              style={{ width: "85%", color: "#ffffff" }}
            >
              Somos un espacio dedicado a fomentar la colaboración entre
              personas interesadas en la gestión integral de residuos sólidos
              urbanos y expertos que desean compartir sus conocimientos.
            </p>
          </Grid>
          <Grid
            container
            xs={12}
            md={7}
            sx={{
              paddingTop: { xs: "0px", md: "48px" },
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            <Grid
              xs={10}
              md={5}
              sx={{
                display: { xs: "flex", sm: "block" },
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <h5 style={{ marginBottom: "0px" }}>Contáctanos</h5>
              <a
                target="_blanck"
                href="https://maps.app.goo.gl/puqxfgAPiya5wC219"
              >
                <img style={{ width: "28px" }} src={maps} alt="ubicación" />
                Guadalajara Jal. México.
              </a>
              <a
                target="_blanck"
                href="mailto:premio@dslatamiswamexico.org?subject=Informaci%C3%B3n%20sobre%20los%20premios%20DS%20Latam&body=Hola%20buen%20d%C3%ADa"
              >
                <img style={{ width: "28px" }} src={mail} alt="ubicación" />
                premio@dslatamiswamexico.org
              </a>
              <a target="_blanck" href="tel:3315379158">
                <img style={{ width: "28px" }} src={phone} alt="ubicación" />
                +52 33 1537 9158
              </a>
            </Grid>
            <Grid
              xs={10}
              md={3}
              sx={{
                display: { xs: "flex", sm: "block" },
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <h5 style={{ marginBottom: "0px" }}>DS LATAM</h5>
              <a href="#cursos">Cursos</a>
              <a target="_blanck" href="https://www.dslatamiswamexico.org">
                Sobre nosotros
              </a>
              <a href="#contacto">Contacto</a>
            </Grid>
            <Grid
              xs={10}
              md={3}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: { xs: "center", sm: "left" },
              }}
            >
              <div>
                <h5 style={{ marginBottom: "0px" }}>¡Síguenos!</h5>
                <div style={{ display: "flex", gap: "25px" }}>
                  <a
                    target="_blanck"
                    href="https://www.facebook.com/Profesionalesenresiduos"
                  >
                    <img
                      style={{ width: "28px" }}
                      src={face}
                      alt="DSLATAM Facebokk"
                    />
                  </a>
                  <a
                    target="_blanck"
                    href="https://www.instagram.com/iswamexico/"
                  >
                    <img
                      style={{ width: "28px" }}
                      src={insta}
                      alt="DSLATAM Instagram"
                    />
                  </a>
                  <a
                    target="_blanck"
                    href="http://www.linkedin.com/in/dslatamprofesionalesenresiduos-4a623b215"
                  >
                    <img
                      style={{ width: "28px" }}
                      src={linkedin}
                      alt="DSLATAM LinkedIn"
                    />
                  </a>
                  <a
                    target="_blanck"
                    href="https://www.youtube.com/@DSLATAMISWAMEXICO"
                  >
                    <img
                      style={{ width: "28px" }}
                      src={youtube}
                      alt="DSLATAM Youtube"
                    />
                  </a>
                </div>
              </div>
              <p style={{ color: "#ffffff" }} className="texto_2 centrar_so">
                Desarrollado por <br />
                <a
                  className="centrar_so_2"
                  style={{
                    textDecoration: "underline",
                  }}
                  target="_blanck"
                  href="https://softwareover.com.mx"
                >
                  Software Over
                </a>
              </p>
              {/* <Link to={"/terminos-y-condiciones"}>Términos y Condiciones</Link>
              <Link to={"/aviso-de-privacidad"}>Política de Privacidad</Link> */}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </footer>
  );
};

export default Footer;
